import { StoreSkuItem } from "@playroomkit/pr-wars-data";
import { ItemImage } from "../ShopComponents";
import { useMemo } from "react";
import clsx from "clsx";
import { useShop } from "@src/contexts/ShopProvider";

interface PodiumGridItemProps extends StoreSkuItem {
  onClick: (sku_id: string) => void;
  showPrice: (price: string | number) => string;
}

export const PodiumGridItem = (props: PodiumGridItemProps) => {
  const { isEquipping, player } = useShop();
  const { sku_id, price, onClick, purchased, metadata, showPrice } = props;

  const label = useMemo(() => {
    if (isEquipping === metadata?.id) return "Equipping...";
    if (player?.podiumId === metadata?.id) return "Equipped";
    if (purchased || player?.allAccess) return "Equip";
    if (!sku_id) return "Coming Soon";
    return null;
  }, [purchased, sku_id, player, isEquipping]);

  return (
    <div
      className={clsx("relative w-full max-h-[26rem] transition", {
        "opacity-50 pointer-events-none": isEquipping,
        "hover:scale-105": !purchased,
      })}
      onClick={() => onClick(sku_id ?? "")}
    >
      <ItemImage
        src={metadata?.image ?? ""}
        className="w-full h-full object-contain"
      />
      {/* Price */}
      {(label || price) && (
        <div className="absolute bottom-5 text-shadow z-10 flex w-full items-center justify-center border-[#C369FF] text-white">
          {label ? (
            <span className="text-xl">{label}</span>
          ) : (
            <span className="text-3xl">{showPrice(price ?? "")}</span>
          )}
        </div>
      )}
    </div>
  );
};
